export enum SubscriptionRequestTypeEnum {
  AddNewSubscription = 1,
  CancelExistingSubscription = 2,
  UpdateExistingSubscription = 3,
}
